import { render, staticRenderFns } from "./UspqrpWrapper.vue?vue&type=template&id=6c4c1438"
import script from "./UspqrpWrapper.vue?vue&type=script&lang=js"
export * from "./UspqrpWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports